/* lua.js generated code 0.3.1 */

let UserLevelTypeBase = require("clover/logic/userLevel/UserLevelTypeBase")
BuildShipUserLevelType = xClass("BuildShipUserLevelType", UserLevelTypeBase)
BuildShipUserLevelType.prototype.canStartLevel = function () {
    return [true]
}
BuildShipUserLevelType.prototype.ctor = function (levelId, itemList) {
    let self = this
    UserLevelTypeBase.prototype.ctor.call(self, levelId, itemList)
    self.levelType = GameLevelType.kBuildShip
}
BuildShipUserLevelType.prototype.getConsumeEnergy = function () {
    return 0
}
BuildShipUserLevelType.prototype.startLevel = function (levelId, itemList, successCallback) {
    UserManager.getInstance().getAndUpdateTimeProps()
    UserProp.getInstance().removeAllTempProps()
    Promise.resolve().then(() => {
        successCallback && successCallback()
    })
}
BuildShipUserLevelType.prototype.canUseProp = function (propId, num)  {
    var self = this
    var [success, errCode] = UserLevelTypeBase.prototype.canUseProp_checkRange.call(self, propId)
    if (!success) {
        return [success, errCode]
    }
    var [success, errCode] = UserLevelTypeBase.prototype.canUseProp_checkUseTime.call(self, propId, num)
    if (!success) {
        return [success, errCode]
    }
    return [true]
}
BuildShipUserLevelType.prototype.endLevel = function (score, star, stageTime, coin, targetCount, opLog, costMove, replay, successCallback, failCallback, cancelCallback, otherData) {
    var self = this
    UserLevel.getInstance().clearCurrentLevel()
    UserManager.getInstance().getAndUpdateTimeProps()
    UserProp.getInstance().removeAllTempProps()
    self.sendEndRequest(score, star, stageTime, coin, targetCount, opLog, costMove, replay, successCallback, failCallback, cancelCallback, otherData)
}
module.exports = BuildShipUserLevelType
